import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

type FilterNumericArgs = {
  id: string
  condition: string
  value: number
}

type FilterTextArgs = {
  id: string
  condition: string
  value: number
}

export type InputProps = {
  parentId: number
}

export type Variables = {
  parentId: number
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

export const SYSTEM_SEARCH_QUERY = gql`
  query getSystemSearch(
    $parentId: Float! = -1
    $numericFilter: [FilterNumericArgs!]
    $textFilter: [FilterTextArgs!]
    $companyId: String
  ) {
    getSystemSearch(
      parentId: $parentId
      numericFilter: $numericFilter
      textFilter: $textFilter
      companyId: $companyId
    ) {
      hierarchy {
        hierarchyId
        elementId
        parentId
        name
      }
      filters {
        range {
          id
          name
          min
          max
          condition
          icon
          predefined_values
        }
        static {
          id
          name
          values
          condition
          icon
        }
      }
      products {
        id
        title
        name
        filters { 
          name
          shortName
          value
          icon
        }
        image
      }
    }
  }
`

const withSystemSearchQuery = graphql<InputProps, Response, Variables, ChildProps>(
  SYSTEM_SEARCH_QUERY,
  {
    name: 'systemSearchData', options: { fetchPolicy: 'network-only' }
  },
)

export default withSystemSearchQuery
